import React from 'react';
import { useMsal } from '@azure/msal-react';
import { Navigate } from 'react-router-dom';

const ISADMIN_CLAIM = process.env.REACT_APP_ENTRA_ISADMIN_CLAIM;

const AdminRoute = ({ children }) => {
  const { accounts } = useMsal();
  const isAdmin = accounts[0]?.idTokenClaims?.[ISADMIN_CLAIM] === true;

  if (!isAdmin) return <Navigate to="/" replace />;

  return children;
};

export default AdminRoute;
